import './style.scss';
import { DisposalSet, onReady } from '@neptune/cx/utils';

const gc = new DisposalSet();

onReady(() => {});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
